import React, { useMemo, useState, useCallback, Fragment } from "react"
import { Image, Alert, View, TouchableOpacity, Platform, StyleSheet } from "~/ui/primitives"
import { observer } from "mobx-react-lite"
import styled from '~/ui/styled'
import { Message, User, useStores } from "../../models"
import { useTheme } from '~/ui/styled'
import { ButtonSolid, ButtonText } from "~components/button"
import MessageSent from "./message-sent"
import MessageReceived from "./message-received"
import { MessageProps } from "./message.props"
import { WrappedTextMessage } from "./text-message"
import { prompt } from "~utils/prompt"
import { ActionsSheet } from "~components/actions-sheet"
import { IconButton } from "~components/icon-button"
import { formatOrderTime, formatPrice, genPrivacyChatID, staticUrl } from "~utils"
import { Text } from "~widgets/text"
import FastImage from "~/ui/FastImage"
import useMediaLibrary from "~hooks/useMediaLibrary"
import Clipboard from "~/ui/clipboard"
import {
  Event,
  EventNames,
  FLAG_ACK,
  TakeOrderStatus,
  ImgAttach,
  PaymentMethod,
  AttachTakeOrderData,
  TakeOrderStatusData,
  MessageTypes,
} from "../../proto"
import ImagePicker from "~/ui/image-picker"
import { Mask } from "~widgets/mask"
import { Heading3, Heading4 } from "~components/heading"
import Icon from "~widgets/icon"
import { alertError, alertWarning } from "~utils/alert"
// import useCountDown from "~hooks/use-countdown"
import { PayPasswordModal } from "~components/pay-password-modal"
import useNavigation from "~hooks/useNavigation"
import { PayTypeModal } from "~components/pay-type-modal"
import { Payment } from "~models/payment"
import * as FileSystem from "~/ui/expo-file-system"
// import { FLAG_REPLY } from "~types/proto"
import DeliveryModal from "~components/delivery-modal"

const placeholder = require("../../assets/images/placeholder.jpg")
const logo = require("../../assets/images/app-intro-logo.png")

const placeholderUri = Image.resolveAssetSource(placeholder).uri
const logoUri = Image.resolveAssetSource(logo).uri

const MainWrap = styled.View`
  align-items: center;
`

const RowBox = styled.View`
  flex-direction: row;
  align-items: center;
`

const OrderWrap = styled.View<{ width?: number }>`
  width: ${({ theme, width }) => `${width || theme.window.width * 0.75}px`};
  margin-bottom: 10px;
`

const OrderMessageTouchableWrap = styled.Pressable`
  background-color: white;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 14px;
  padding-right: 14px;
  border-radius: 14px;
  margin-right: 5px;
  margin-bottom: 10px;
`

const HeaderArea = styled.View`
  width: 100%;
  flex-direction: column;
`

const HeaderPriceArea = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: flex-end;
`

const HeaderPerPriceWrap = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: flex-end;
`

const HeaderPerPriceText = styled.Text`
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: bold;
`

const HeaderPerPriceLabel = styled.Text`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  line-height: 20px;
  font-weight: 400;
`

const HeaderVolumeText = styled.Text`
  color: ${({ theme }) => theme.colors.secondaryText};
`
const HeaderCountText = styled.Text`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  font-weight: bold;
`

const ContentArea = styled.View`
  justify-content: center;
  align-items: center;
  padding-top: ${({ theme }) => theme.space.md};
  padding-bottom: ${({ theme }) => theme.space.sm};
`
const ContentImage = styled.View<{ align?: string }>`
  justify-content: center;
  align-items: ${({ align }) => align || "flex-end"};
  padding-bottom: ${({ theme }) => theme.space.sm};
`

const ContentCountLabel = styled.Text`
  color: ${({ theme }) => theme.colors.secondaryText};
`

const ContentMainWrap = styled.View`
  padding-top: ${({ theme }) => theme.space.xs};
  flex-direction: row;
  align-items: flex-end;
  padding-bottom: ${({ theme }) => theme.space.md};
`

const ContentMainCountText = styled.Text`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
`

const ContentMainCountUnitLabel = styled.Text`
  color: ${({ theme }) => theme.colors.primary};
  line-height: ${Platform.OS === "android" ? 28 : 24}px;
`

const ContentMainStatusLabel = styled.Text`
  color: ${({ theme }) => theme.colors.secondaryText};
`

const MoreArea = styled.View`
  padding-bottom: ${({ theme }) => theme.space.sm};
`

const MoreItemWrap = styled.View`
  flex-direction: row;
  padding-top: ${({ theme }) => theme.space.sm};
  padding-bottom: ${({ theme }) => theme.space.sm};
`

const MoreItemLabel = styled.Text`
  margin-right: ${({ theme }) => theme.space.sm};
  color: ${({ theme }) => theme.colors.secondaryText};
`
const MoreItemValueWrap = styled.View`
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const MoreItemValue = styled.Text`
  width: 80%;
`

const FooterArea = styled.View`
  justify-content: center;
  align-items: center;
  border-top-width: ${StyleSheet.hairlineWidth}px;
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.secondaryText};
  padding-top: ${({ theme }) => theme.space.sm};
  padding-bottom: ${({ theme }) => theme.space.xs};
`

const BottomArea = styled.View<{ paddingBottom: number }>`
  flex-direction: row;
  justify-content: space-around;
  margin: 0 -5px;
  /* background-color: #ccc; */
`

const ButtonWrap = styled.TouchableOpacity`
  flex: 1;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  border-style: solid;
  border-color: ${({ theme }) => theme.colors.border};
  border-radius: 10px;
  padding: 10px 0;
  margin: 0 5px;
  justify-content: center;
  align-items: center;
`

const RowGap = styled.View`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.border};
  height: ${StyleSheet.hairlineWidth}px;
`

const ContentScanAlertText = styled.Text`
  color: ${({ theme }) => theme.colors.secondaryText};
`
const ContentSellerNameText = styled.Text`
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes.lg};
`
const ActionPopup = styled.Modal``
const ActionPopupContent = styled.View`
  width: 100%;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  padding-left: ${({ theme }) => theme.space.md};
  padding-right: ${({ theme }) => theme.space.md};
  padding-bottom: ${({ theme }) => theme.space.xl};
  background-color: white;
`
const ActionPopupTitleWrap = styled.View`
  padding: ${({ theme }) => theme.space.lg};
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const ActionPopupAlertWrap = styled.View`
  padding: ${({ theme }) => theme.space.sm};
  background-color: ${({ theme }) => theme.colors.secondary};
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
const ActionPopupAlertText = styled.Text`
  color: ${({ theme }) => theme.colors.primary};
`
const ActionPopupContentActionsWrap = styled.ScrollView`
  padding: ${({ theme }) => theme.space.md};
`
const SettledWrap = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: flex-end;
  padding: 5px;
`
const SettledWrapLeft = styled.View`
  justify-content: center;
`
const SettledWrapRight = styled.View`
  flex: 1;
  align-items: flex-end;
`
const SettledPriceText = styled.Text`
  color: ${({ theme }) => theme.colors.blockBackground};
  font-weight: 500;
  font-size: 40px;
`
const SettledLabel = styled.Text`
  color: rgb(166, 221, 255);
`
const CopyTouchable = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
`

export const orderStatusText = {
  [TakeOrderStatus.PENDING]: {
    text: "待卖家确认订单",
    color: "rgb(192, 94, 252)",
    order_status_title: "",
    order_status_text: "待卖家确认订单",
    order_status_text_next: "卖家已确认订单",
    next_factor: "approved",
    order_status_color: "primary",
    description: "您好, 请确认订单信息",
  },
  [TakeOrderStatus.PENDING_TIMEOUT]: {
    text: "订单超时",
    color: "rgb(255, 0, 0)",
    order_status_title: "",
    order_status_text: "订单超时",
    order_status_text_next: "订单超时",
    next_factor: "",
    order_status_color: "danger",
    description: "很抱歉, 此订单在确认订单信息阶段超时",
  },
  [TakeOrderStatus.CANCELLED]: {
    text: "买家取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "买家取消交易",
    order_status_text_next: "买家取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "您好, 我已取消交易",
  },
  [TakeOrderStatus.SELLER_CANCELLED]: {
    text: "卖家取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "卖家取消交易",
    order_status_text_next: "卖家取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "您好, 我已取消交易",
  },
  [TakeOrderStatus.MATCHING]: {
    text: "待付款",
    color: "rgb(224, 113, 50)",
    order_status_title: "",
    order_status_text: "订单已建立",
    order_status_text_next: "订单已建立",
    next_factor: "",
    order_status_color: "primary",
    description: "请根据我的收款信息完成支付, 并上传转账凭证, 谢谢",
  },
  [TakeOrderStatus.MATCHING_CANCELLED]: {
    text: "买家取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "买家取消交易",
    order_status_text_next: "买家取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "您好, 我已取消交易",
  },
  [TakeOrderStatus.MATCHING_TIMEOUT]: {
    text: "转账阶段超时",
    color: "rgb(255, 0, 0)",
    order_status_title: "",
    order_status_text: "转账阶段超时",
    order_status_text_next: "转账阶段超时",
    next_factor: "",
    order_status_color: "danger",
    description: "很抱歉, 此订单在缴款阶段超时",
  },
  [TakeOrderStatus.DELIVERING]: {
    text: "待卖家发货",
    color: "rgb(192, 94, 252)",
    order_status_title: "",
    order_status_text: "买家完成转账, 待卖家确认",
    order_status_text_next: "买家完成转账, 卖家已验证",
    next_factor: "settled",
    order_status_color: "primary",
    description: "我已支付, 请查收, 谢谢您",
  },
  [TakeOrderStatus.SETTLED]: {
    text: "卖家已发货,待评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "卖家已发货",
    order_status_text_next: "卖家已发货",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成, 待评价",
  },
  [TakeOrderStatus.DELIVERY_TIMEOUT]: {
    text: "订单已转系统验证",
    color: "rgb(161, 161, 161)",
    order_status_title: "发货超时",
    order_status_text: "订单已转系统验证",
    order_status_text_next: "订单已转系统验证",
    next_factor: "",
    order_status_color: "danger",
    description: "卖家发货超时，订单已转系统验证",
  },
  [TakeOrderStatus.DISPUTE]: {
    text: "待系统发货",
    color: "rgb(90, 149, 236)",
    order_status_title: "",
    order_status_text: "交易由系统接手, 待系统验证",
    order_status_text_next: "系统已验证",
    next_factor: "settled",
    order_status_color: "primary",
    description: "等待系统处理中",
  },
  [TakeOrderStatus.SYSTEM_CANCELLED]: {
    text: "系统取消交易",
    color: "rgb(161, 161, 161)",
    order_status_title: "",
    order_status_text: "系统取消交易",
    order_status_text_next: "系统取消交易",
    next_factor: "",
    order_status_color: "danger",
    description: "很抱歉, 此订单已由系统取消",
  },
  [TakeOrderStatus.SYSTEM_SETTLED]: {
    text: "系统已发货",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "系统已发货",
    order_status_text_next: "系统已发货",
    next_factor: "",
    order_status_color: "success",
    description: "已由系统交易完成, 请查收",
  },
  [TakeOrderStatus.EVALUATED]: {
    text: "交易完成,买家已评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "交易完成,买家已评价",
    order_status_text_next: "交易完成,买家已评价",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成,买家已评价",
  },
  [TakeOrderStatus.EVALUATED_SR]: {
    text: "交易完成,卖家已评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "交易完成,卖家已评价",
    order_status_text_next: "交易完成,卖家已评价",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成,卖家已评价",
  },
  [TakeOrderStatus.EVALUATED_ALL]: {
    text: "交易完成,已评价",
    color: "rgb(32, 190, 161)",
    order_status_title: "",
    order_status_text: "交易完成,已评价",
    order_status_text_next: "交易完成,已评价",
    next_factor: "",
    order_status_color: "success",
    description: "交易完成,已评价",
  },
}
//
export const paymentMethodTextMap = {
  [PaymentMethod.BANK]: "银行卡",
  [PaymentMethod.ALIPAY]: "支付宝",
  [PaymentMethod.WECHAT]: "微信",
}
// 超时
export const timeout = [
  TakeOrderStatus.DELIVERY_TIMEOUT,
  TakeOrderStatus.MATCHING_TIMEOUT,
  TakeOrderStatus.PENDING_TIMEOUT,
]
// 取消
export const cancel = [
  TakeOrderStatus.CANCELLED,
  TakeOrderStatus.MATCHING_CANCELLED,
  TakeOrderStatus.SELLER_CANCELLED,
  TakeOrderStatus.SYSTEM_CANCELLED,
]
// 完成
export const settle = [
  TakeOrderStatus.SETTLED,
  TakeOrderStatus.SYSTEM_SETTLED,
  TakeOrderStatus.EVALUATED,
  TakeOrderStatus.EVALUATED_SR,
  TakeOrderStatus.EVALUATED_ALL,
]

interface OrderMessageProps {
  message: Message
  order: AttachTakeOrderData
  isSeller?: boolean
  cancel?: () => void
  approve?: (payment: Payment) => void
  remind?: () => void
  pay?: (imgs: ImgAttach[]) => void
  dispute?: () => void
  settle?: () => void
  contactCs?: () => void
  handleOnLongPress?: () => void
  setPopupOptionListModal?: ({ visible, message }: { visible: boolean; message: Message }) => void
}
const onCopy = (v: string) => {
  Clipboard.setString(v)
  Alert.alert("复制成功")
}
const OrderHeader: React.FC<{ order: AttachTakeOrderData }> = ({ order }) => {
  const getContent = () => {
    const total = Number(order?.pending_order_info?.quantities || 0)
    const stock = Number(order?.pending_order_info?.stock || 0)
    return (
      "成单量 " +
      (total - stock).toString() +
      " | " +
      Math.round((stock / total) * 10000) / 100 +
      "%"
    )
  }
  return (
    <HeaderArea>
      <HeaderPriceArea>
        <HeaderPerPriceWrap>
          <HeaderPerPriceText>{order.amount}</HeaderPerPriceText>
          <HeaderPerPriceLabel>/单价</HeaderPerPriceLabel>
        </HeaderPerPriceWrap>
        <HeaderVolumeText>{getContent()}</HeaderVolumeText>
      </HeaderPriceArea>
    </HeaderArea>
  )
}
const OrderContent: React.FC<{ order: AttachTakeOrderData; children?: React.ReactNode }> = ({
  order,
  children,
}) => {
  const theme = useTheme()
  const Content = () => {
    const statusDataMap = orderStatusText[order.status]
    const nextFactor = statusDataMap.next_factor ? order[statusDataMap.next_factor] : false
    return (
      <>
        <ContentMainStatusLabel>订单状态:</ContentMainStatusLabel>
        <Text
          style={{
            color: theme.colors[statusDataMap.order_status_color],
          }}
        >
          {nextFactor ? statusDataMap?.order_status_text_next : statusDataMap.order_status_text}
        </Text>
      </>
    )
  }
  return (
    <ContentArea>
      <ContentCountLabel>交易数量</ContentCountLabel>
      <ContentMainWrap>
        <ContentMainCountText>{formatPrice(order.quantities)}</ContentMainCountText>
        <ContentMainCountUnitLabel> 红包APP币</ContentMainCountUnitLabel>
      </ContentMainWrap>
      {children || <Content />}
    </ContentArea>
  )
}
const OrderMore: React.FC<OrderMessageProps> = observer(({ message }) => {
  const theme = useTheme()
  const [more, setMore] = useState(false)

  const onMore = (v: boolean) => {
    setMore(v)
  }
  const {
    history_deals,
    payment_method,
    trans_no,
    order_no,
    real_name,
    options,
  } = message.attach.order
  return (
    <>
      {more && (
        <MoreArea>
          <MoreItemWrap>
            <MoreItemLabel>与我交易成功次数:</MoreItemLabel>
            <MoreItemValueWrap>
              <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                {history_deals}
              </MoreItemValue>
            </MoreItemValueWrap>
          </MoreItemWrap>
          <RowGap />
          <MoreItemWrap>
            <MoreItemLabel>买家姓名:</MoreItemLabel>
            <MoreItemValueWrap>
              <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                {real_name}
              </MoreItemValue>
              {/* <ButtonText
                onClick={() => onCopy(real_name)}
                text="复制"
                color={theme.colors.primary}
                fontSize={ButtonFontSizes.S}
              /> */}
              <CopyTouchable onClick={() => onCopy(real_name)}>
                <Icon name={"copy"} size={16} color={"#07c160"} />
              </CopyTouchable>
            </MoreItemValueWrap>
          </MoreItemWrap>
          <RowGap />
          <MoreItemWrap>
            <MoreItemLabel>支付方式:</MoreItemLabel>
            <MoreItemValueWrap>
              <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                {paymentMethodTextMap[payment_method]}
              </MoreItemValue>
            </MoreItemValueWrap>
          </MoreItemWrap>
          <RowGap />
          {payment_method === 1 && options?.pay_account ? (
            <Fragment>
              <MoreItemWrap>
                <MoreItemLabel>支付宝账号:</MoreItemLabel>
                <MoreItemValueWrap>
                  <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                    {options?.pay_account || ""}
                  </MoreItemValue>
                  {/* <ButtonText
                  onClick={() => onCopy(options?.pay_account)}
                  text="复制"
                  color={theme.colors.primary}
                  fontSize={ButtonFontSizes.S}
                /> */}
                  <CopyTouchable onClick={() => onCopy(options?.pay_account)}>
                    <Icon name={"copy"} size={16} color={"#07c160"} />
                  </CopyTouchable>
                </MoreItemValueWrap>
              </MoreItemWrap>
              <RowGap />
            </Fragment>
          ) : null}
          <MoreItemWrap>
            <MoreItemLabel>挂单编号:</MoreItemLabel>
            <MoreItemValueWrap>
              <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                {order_no}
              </MoreItemValue>
              {/* <ButtonText
                onClick={() => onCopy(order_no)}
                text="复制"
                color={theme.colors.primary}
                fontSize={ButtonFontSizes.S}
              /> */}
              <CopyTouchable onClick={() => onCopy(order_no)}>
                <Icon name={"copy"} size={16} color={"#07c160"} />
              </CopyTouchable>
            </MoreItemValueWrap>
          </MoreItemWrap>
          <MoreItemWrap>
            <MoreItemLabel>订单编号:</MoreItemLabel>
            <MoreItemValueWrap>
              <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                {trans_no}
              </MoreItemValue>
              {/* <ButtonText
                onClick={() => onCopy(trans_no)}
                text="复制"
                color={theme.colors.primary}
                fontSize={ButtonFontSizes.S}
              /> */}
              <CopyTouchable onClick={() => onCopy(trans_no)}>
                <Icon name={"copy"} size={16} color={"#07c160"} />
              </CopyTouchable>
            </MoreItemValueWrap>
          </MoreItemWrap>
          <RowGap />
          <MoreItemWrap>
            <MoreItemLabel>下单时间:</MoreItemLabel>
            <MoreItemValueWrap>
              <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                {formatOrderTime(new Date(message.created))}
              </MoreItemValue>
            </MoreItemValueWrap>
          </MoreItemWrap>
        </MoreArea>
      )}
      <FooterArea>
        <ButtonText
          text={more ? "收起" : "查看更多"}
          color={theme.colors.primary}
          onClick={() => onMore(!more)}
        />
      </FooterArea>
    </>
  )
})
export const OrderDefaultTemplate: React.FC<OrderMessageProps> = observer(
  ({ message, handleOnLongPress }) => {
    const order = message.attach.order
    return (
      <OrderWrap>
        <OrderMessageTouchableWrap onLongPress={handleOnLongPress}>
          {/* <ExpireCountDown message={message} /> */}
          <OrderHeader order={order} />
          <OrderContent order={order} />
          {!order.edited && <OrderMore message={message} order={order} />}
        </OrderMessageTouchableWrap>
      </OrderWrap>
    )
  },
)
export const OrderPending: React.FC<OrderMessageProps> = observer(
  ({ message, cancel, remind, handleOnLongPress, isSeller, approve }) => {
    const theme = useTheme()
    const [isModalVisible, setIsModalVisible] = useState(false)

    const order = message.attach.order

    const onCancel = () => {
      prompt({
        title: "温馨提示",
        message: `是否取消交易`,
        onSuccess: cancel,
      })
    }
    const onApprove = () => {
      setIsModalVisible(true)
    }
    const start = (payment: Payment) => {
      prompt({
        message: `是否开始交易`,
        onSuccess: () => {
          approve(payment)
        },
      })
    }
    const onRemind = () => {
      remind()
    }

    return (
      <>
        <OrderWrap>
          <OrderMessageTouchableWrap onLongPress={handleOnLongPress}>
            {/* <ExpireCountDown message={message} /> */}
            <OrderHeader order={order} />
            <OrderContent order={order} />
            {!order.edited && <OrderMore message={message} order={order} />}
          </OrderMessageTouchableWrap>
          {!order.edited && (
            <BottomArea paddingBottom={0}>
              <ButtonWrap onClick={onCancel}>
                <ButtonText text="取消交易" color={theme.colors.infoText} onClick={onCancel} />
              </ButtonWrap>
              {/* <ColumnGap /> */}
              {isSeller ? (
                <ButtonWrap onClick={onApprove}>
                  <ButtonText text="开始交易" color={theme.colors.primary} onClick={onApprove} />
                </ButtonWrap>
              ) : (
                <ButtonWrap onClick={onRemind}>
                  <ButtonText text="提醒他" color={theme.colors.primary} onClick={onRemind} />
                </ButtonWrap>
              )}
            </BottomArea>
          )}
        </OrderWrap>
        <PayTypeModal
          paymentMethods={[order.payment_method]}
          callBack={(payment) => {
            start(payment)
          }}
          title={"选择收款方式"}
          visible={isModalVisible}
          setVisible={setIsModalVisible}
        ></PayTypeModal>
      </>
    )
  },
)
export const OrderWaitForPay: React.FC<OrderMessageProps> = observer(
  ({ message, handleOnLongPress, cancel, pay, isSeller, contactCs }) => {
    const navigation = useNavigation()
    const { apiStore, bankStore } = useStores()
    const { bankList } = bankStore
    const theme = useTheme()
    const [isShowUploadPaiedVoucher, setIsShowUploadPaiedVoucher] = useState(false)
    const [isShowActionSheet, setIsShowActionSheet] = useState(false)
    const [loading, setLoading] = useState(false)
    const [imgs, setImgs] = useState([])
    const [curImgIndex, setCurImgIndex] = useState(0)
    const [needDelete, setNeedDelete] = useState(false)
    const order = message.attach.order
    const { amount, quantities, options, payment_method, seller_real_name, edited } = order
    const onCancel = () => {
      prompt({
        title: "温馨提示",
        message: `是否取消交易`,
        onSuccess: cancel,
      })
    }
    const openUploadModal = () => {
      setIsShowUploadPaiedVoucher(true)
    }
    const onPay = () => {
      if (imgs.length >= 1) {
        pay(imgs)
        setIsShowUploadPaiedVoucher(false)
      } else {
        alertWarning({ message: "请先上传支付证明" })
      }
    }

    const onContactCs = () => {
      contactCs()
    }

    const { saveAsset, requestPermissionsAsyncWithCallback } = useMediaLibrary({ writeOnly: false })

    const saveImage = useCallback(
      async ({ uri }) => {
        try {
          setLoading(true)
          await requestPermissionsAsyncWithCallback({
            callback: () => {
              const fileUri =
                FileSystem.documentDirectory +
                Date.now().toString() +
                "." +
                uri.split(".").reverse()[0].toLowerCase()
              FileSystem.downloadAsync(uri, fileUri)
                .then(async ({ uri }) => {
                  await saveAsset({ uri })
                })
                .catch((error) => {
                  throw error
                })
            },
          })
        } catch (e) {
          alertError({ message: e.message })
        } finally {
          setLoading(false)
        }
      },
      [requestPermissionsAsyncWithCallback],
    )

    const onOpenPicturePicker = useCallback(async () => {
      const { path, filename, mime, size } = await ImagePicker.openPicker({
        cropping: false,
        multiple: false,
        mediaType: "photo",
        loadingLabelText: "处理中...",
      })
      try {
        setLoading(true)
        const { uri } = await apiStore.upload({ path, type: "image/jpeg" })
        setImgs((prev) => {
          prev.splice(curImgIndex, 1, {
            url: uri,
            filename,
            type: mime,
            size,
          })
          return prev
        })
      } catch (e) {
        // console.warn(e)
      } finally {
        setLoading(false)
      }
    }, [curImgIndex])

    const deleteImage = useCallback(async () => {
      setImgs((prev) => {
        prev.splice(curImgIndex, 1)
        return [...prev]
      })
    }, [curImgIndex])

    const actionOptions = useMemo(() => {
      const options = [
        { text: needDelete ? "更换图片" : "从相册选一张", onClick: onOpenPicturePicker },
        { text: "取消" },
      ]
      if (needDelete) {
        options.splice(1, 0, { text: "删除", onClick: deleteImage })
      }
      return options
    }, [onOpenPicturePicker, deleteImage, needDelete, curImgIndex])

    const qrcodeStyle = { width: theme.window.width / 2, height: theme.window.width / 2 }
    const imgStyle = { width: theme.window.width / 6, height: theme.window.width / 6 }
    const bankListObject = Object.fromEntries(bankList)

    return (
      <OrderWrap>
        <OrderMessageTouchableWrap onLongPress={handleOnLongPress}>
          <HeaderArea>
            {/* <ExpireCountDown message={message} /> */}
            {/* <StatusText order={order} />
            <OrderNoText>{order.order_no}</OrderNoText> */}
            <HeaderPriceArea>
              <HeaderPerPriceWrap>
                <HeaderPerPriceText>{amount}</HeaderPerPriceText>
                <HeaderPerPriceLabel>/单价</HeaderPerPriceLabel>
              </HeaderPerPriceWrap>
              <HeaderVolumeText>
                交易数量: <HeaderCountText>{formatPrice(quantities)}</HeaderCountText>红包APP币
              </HeaderVolumeText>
            </HeaderPriceArea>
          </HeaderArea>
          <ContentArea>
            <ContentCountLabel>交易金额</ContentCountLabel>
            <ContentMainWrap>
              <ContentMainCountText>{formatPrice(amount * quantities)}</ContentMainCountText>
              <ContentMainCountUnitLabel> CNY</ContentMainCountUnitLabel>
            </ContentMainWrap>
            {payment_method === 0 && options?.bank_name ? (
              <Fragment>
                <MoreItemWrap>
                  <MoreItemLabel>收款姓名:</MoreItemLabel>
                  <MoreItemValueWrap>
                    <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                      {options?.real_name || ""}
                    </MoreItemValue>
                    {/* <ButtonText
                      onClick={() => onCopy(options?.real_name)}
                      text="复制"
                      color={theme.colors.primary}
                      fontSize={ButtonFontSizes.S}
                    /> */}
                    <CopyTouchable onClick={() => onCopy(options?.real_name)}>
                      <Icon name={"copy"} size={16} color={"#07c160"} />
                    </CopyTouchable>
                  </MoreItemValueWrap>
                </MoreItemWrap>
                <RowGap />
                <MoreItemWrap>
                  <MoreItemLabel>收款银行:</MoreItemLabel>
                  <MoreItemValueWrap>
                    <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                      {bankListObject[options?.bank_name] || ""}
                    </MoreItemValue>
                    {/* <ButtonText
                      onClick={() => onCopy(bankListObject[options?.bank_name])}
                      text="复制"
                      color={theme.colors.primary}
                      fontSize={ButtonFontSizes.S}
                    /> */}
                    <CopyTouchable onClick={() => onCopy(bankListObject[options?.bank_name])}>
                      <Icon name={"copy"} size={16} color={"#07c160"} />
                    </CopyTouchable>
                  </MoreItemValueWrap>
                </MoreItemWrap>
                <RowGap />
                <MoreItemWrap>
                  <MoreItemLabel>收款卡号:</MoreItemLabel>
                  <MoreItemValueWrap>
                    <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                      {options?.pay_account || ""}
                    </MoreItemValue>
                    {/* <ButtonText
                      onClick={() => onCopy(options?.pay_account)}
                      text="复制"
                      color={theme.colors.primary}
                      fontSize={ButtonFontSizes.S}
                    /> */}
                    <CopyTouchable onClick={() => onCopy(options?.pay_account)}>
                      <Icon name={"copy"} size={16} color={"#07c160"} />
                    </CopyTouchable>
                  </MoreItemValueWrap>
                </MoreItemWrap>
                <RowGap />
                <MoreItemWrap>
                  <MoreItemLabel>收款支行:</MoreItemLabel>
                  <MoreItemValueWrap>
                    <MoreItemValue numberOfLines={1} ellipsizeMode="middle">
                      {options?.bank_branch || ""}
                    </MoreItemValue>
                    {/* <ButtonText
                      onClick={() => onCopy(options?.bank_branch)}
                      text="复制"
                      color={theme.colors.primary}
                      fontSize={ButtonFontSizes.S}
                    /> */}
                    <CopyTouchable onClick={() => onCopy(options?.bank_branch)}>
                      <Icon name={"copy"} size={16} color={"#07c160"} />
                    </CopyTouchable>
                  </MoreItemValueWrap>
                </MoreItemWrap>
                <RowGap />
              </Fragment>
            ) : (
              <Fragment>
                <TouchableOpacity
                  onClick={() => {
                    navigation.navigate("ImageGallery", {
                      images: [{ url: staticUrl(options?.pay_image) }],
                      index: 0,
                    })
                  }}
                  style={{ marginTop: -15 }}
                >
                  <FastImage
                    style={qrcodeStyle}
                    src={staticUrl(options?.pay_image) || placeholderUri}
                    resizeMode={FastImage.resizeMode.cover}
                  />
                </TouchableOpacity>
                <ContentScanAlertText style={{ marginBottom: 12 }}>
                  {paymentMethodTextMap[payment_method]}扫一扫, 向我付款
                </ContentScanAlertText>
              </Fragment>
            )}

            <RowBox style={{ marginTop: 10 }}>
              <ContentSellerNameText>卖家姓名: {seller_real_name} </ContentSellerNameText>
              {!isSeller && (
                // <ButtonText
                //   onClick={() => onCopy(seller_real_name)}
                //   text="复制"
                //   color={theme.colors.primary}
                // />
                <CopyTouchable onClick={() => onCopy(seller_real_name)}>
                  <Icon name={"copy"} size={16} color={"#07c160"} />
                </CopyTouchable>
              )}
            </RowBox>
          </ContentArea>
          {!order.edited && <OrderMore message={message} order={order} />}
          {!isSeller && !edited && (
            <FooterArea>
              <ButtonText
                disabled={loading}
                text={"保存二维码"}
                color={theme.colors.primary}
                onClick={() => {
                  saveImage({
                    uri: options?.pay_image ? staticUrl(options.pay_image) : placeholderUri,
                  })
                }}
              />
            </FooterArea>
          )}
        </OrderMessageTouchableWrap>
        {!isSeller && !edited && (
          <BottomArea paddingBottom={0}>
            <ButtonWrap onClick={onCancel}>
              <ButtonText text="取消交易" color={theme.colors.infoText} onClick={onCancel} />
            </ButtonWrap>
            {/* <ColumnGap /> */}
            <ButtonWrap onClick={openUploadModal}>
              <ButtonText text="我已转账" color={theme.colors.primary} onClick={openUploadModal} />
            </ButtonWrap>
          </BottomArea>
        )}
        {!isSeller && edited && (
          <BottomArea paddingBottom={0}>
            <ButtonWrap onClick={onContactCs}>
              <ButtonText text="联系客服" color={theme.colors.primary} onClick={onContactCs} />
            </ButtonWrap>
          </BottomArea>
        )}
        <ActionPopup
          visible={isShowUploadPaiedVoucher}
          transparent={true}
          animationType="slide"
          hardwareAccelerated={true}
        >
          <Mask backgroundColor="transparent" justifyContent="flex-end">
            <ActionPopupContent
              style={{
                shadowColor: "#171717",
                shadowOffset: { width: -2, height: 0 },
                shadowOpacity: 0.2,
                shadowRadius: 3,
              }}
            >
              <ActionPopupTitleWrap>
                <Heading4 text={`上传支付证明`} />
                <TouchableOpacity
                  style={{ position: "absolute", right: 5 }}
                  onClick={() => setIsShowUploadPaiedVoucher(false)}
                >
                  <Icon name="close" color={"#000000"} size={25} />
                </TouchableOpacity>
              </ActionPopupTitleWrap>
              <ActionPopupAlertWrap>
                <ActionPopupAlertText>收付款信息平台将加密处理, 请放心添加</ActionPopupAlertText>
              </ActionPopupAlertWrap>
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Heading3 text={`支付证明`} />
                <ActionPopupContentActionsWrap
                  horizontal={true}
                  contentContainerStyle={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {imgs.map((img, i) => {
                    return (
                      <TouchableOpacity
                        key={`${img.url}-${i}`}
                        onClick={() => {
                          setCurImgIndex(i)
                          setIsShowActionSheet(true)
                          setNeedDelete(true)
                        }}
                      >
                        <FastImage
                          style={[imgStyle, { marginRight: 10 }]}
                          src={img.url ? staticUrl(img.url) : placeholderUri}
                          resizeMode={FastImage.resizeMode.cover}
                        />
                      </TouchableOpacity>
                    )
                  })}
                  {imgs.length < 4 && (
                    <IconButton
                      onClick={() => {
                        if (loading) return
                        setIsShowActionSheet(true)
                        setCurImgIndex(imgs.length)
                        setNeedDelete(false)
                      }}
                    ></IconButton>
                  )}
                </ActionPopupContentActionsWrap>
              </View>
              <ButtonSolid loading={loading} text="提交转账截图" onClick={onPay} />
            </ActionPopupContent>
          </Mask>
        </ActionPopup>
        <ActionsSheet
          visible={isShowActionSheet}
          setVisible={setIsShowActionSheet}
          data={actionOptions}
        />
      </OrderWrap>
    )
  },
)

// TODO:
export const OrderPaied: React.FC<OrderMessageProps> = observer(
  ({ message, dispute, settle, contactCs, handleOnLongPress, isSeller }) => {
    const order = message?.attach?.order
    const navigation = useNavigation()
    const theme = useTheme()
    // const imgStyle = { width: 200, height: 200 }
    const [isCheckPassSettle, setIsCheckPassSettle] = useState(false)
    const [isCheckPassDispute, setIsCheckPassDispute] = useState(false)

    const [isWarningModalShow, setIsWarningModalShow] = useState(false) // 发货弹窗显示
    const onSettle = () => {
      setIsCheckPassSettle(true) // 确认密码弹窗 TODO:
      // setIsWarningModalShow(true)
    }
    const onDispute = () => {
      // setIsCheckPassDispute(true)
      navigation.navigate("MyComplaintForm", {
        order_no: order.order_no,
        message: message,
      })
    }
    const onContactCs = () => {
      contactCs()
    }
    const checkPassSettle = (val) => {
      if (val) {
        setIsCheckPassSettle(false)
        settle()
      } else {
        setIsCheckPassSettle(false)
      }
    }
    const checkPassDispute = (val) => {
      if (val) {
        setIsCheckPassDispute(false)
        dispute()
      } else {
        setIsCheckPassDispute(false)
      }
    }
    return (
      <>
        <OrderWrap width={theme.window.width / 1.5}>
          <ContentImage align={!message.byMe ? "flex-start" : ""}>
            {/* <ActionPopupContentActionsWrap
                horizontal={true}
                contentContainerStyle={{
                  justifyContent: "center",
                  alignItems: "center",
                }}
              > */}
            {order.imgs.map((img, i) => {
              return (
                <TouchableOpacity
                  style={{ marginBottom: 10 }}
                  key={`${img}-${i}`}
                  onClick={() => {
                    navigation.navigate("ImageGallery", {
                      images: order.imgs,
                      index: i,
                    })
                  }}
                >
                  <FastImage
                    style={{ width: 90, height: 180 }}
                    src={img.url ? staticUrl(img.url) : placeholderUri}
                    resizeMode={FastImage.resizeMode.cover}
                  />
                </TouchableOpacity>
              )
            })}
            {/* </ActionPopupContentActionsWrap> */}
          </ContentImage>
          <OrderMessageTouchableWrap onLongPress={handleOnLongPress}>
            {/* <ExpireCountDown message={message} /> */}
            <OrderHeader order={order} />
            <OrderContent order={order}>
              {isSeller && order.disputed && (
                <>
                  <ContentMainStatusLabel>订单状态:</ContentMainStatusLabel>
                  <Text
                    style={{
                      color: theme.colors.warning,
                    }}
                  >
                    已转交系统验证
                  </Text>
                </>
              )}
            </OrderContent>
          </OrderMessageTouchableWrap>
          {isSeller && !order.settled && !order.edited && (
            <BottomArea paddingBottom={0}>
              <ButtonWrap onClick={onDispute}>
                <ButtonText text="异常订单" color={theme.colors.primary} onClick={onDispute} />
              </ButtonWrap>
              {order.status !== TakeOrderStatus.DELIVERY_TIMEOUT ? (
                <Fragment>
                  {/* <ColumnGap /> */}
                  <ButtonWrap onClick={onSettle}>
                    <ButtonText text="发货" color={theme.colors.primary} onClick={onSettle} />
                  </ButtonWrap>
                </Fragment>
              ) : null}
            </BottomArea>
          )}
          {isSeller && !order.settled && order.edited && (
            <BottomArea paddingBottom={0}>
              <ButtonWrap onClick={onContactCs}>
                <ButtonText text="联系客服" color={theme.colors.primary} onClick={onContactCs} />
              </ButtonWrap>
            </BottomArea>
          )}
          {!isSeller && (
            <BottomArea paddingBottom={0}>
              <ButtonWrap onClick={onContactCs}>
                <ButtonText text="联系客服" color={theme.colors.primary} onClick={onContactCs} />
              </ButtonWrap>
            </BottomArea>
          )}
        </OrderWrap>
        <PayPasswordModal
          visible={isCheckPassSettle}
          setVisible={setIsCheckPassSettle}
          callBack={checkPassSettle}
        ></PayPasswordModal>
        <PayPasswordModal
          visible={isCheckPassDispute}
          setVisible={setIsCheckPassDispute}
          callBack={checkPassDispute}
        ></PayPasswordModal>
        <DeliveryModal
          order={order}
          visible={isWarningModalShow}
          setVisible={setIsWarningModalShow}
        ></DeliveryModal>
      </>
    )
  },
)
export const OrderSettled: React.FC<OrderMessageProps> = observer(
  ({ message, handleOnLongPress }) => {
    const { walletStore, userStore } = useStores()

    // console.log(message)
    const navigation = useNavigation()
    const theme = useTheme()
    const order = message.attach.order
    const isSeller = order.seller_id === userStore.currentUser.id

    const goEvaluate = () => {
      navigation.navigate("TakeOrderDetail", {
        order,
      })
    }
    const shouldShowEvaluateButton = () => {
      // 不是属于我发的 不出现去评价
      if (!message.byMe) return false

      // 订单状态等于 8 双方未评价 可以出现
      if (order.status === TakeOrderStatus.SETTLED) {
        return true
      }

      /* 判读是不是我的出售的订单
       *  EVALUATED = 13  买家已评价，卖家未评价
       *  EVALUATED_SR = 14 卖家已评价，买家未评价
       */
      if (isSeller) {
        return order.status === TakeOrderStatus.EVALUATED
      } else {
        return order.status === TakeOrderStatus.EVALUATED_SR
      }
    }

    return (
      <OrderWrap>
        <OrderMessageTouchableWrap
          onLongPress={handleOnLongPress}
          style={{ backgroundColor: theme.colors.primary }}
        >
          <SettledWrap
            onClick={() => {
              walletStore.getWalletInfo()
              navigation.navigate("Wallet")
            }}
          >
            <SettledWrapLeft>
              <FastImage
                style={{ width: 60, height: 60 }}
                src={logoUri}
                resizeMode={FastImage.resizeMode.cover}
              />
            </SettledWrapLeft>
            <SettledWrapRight>
              <SettledLabel>红包APP币</SettledLabel>
              <SettledPriceText>
                {message.byMe ? (isSeller ? "-" : "+") : isSeller ? "+" : "-"}
                {formatPrice(order.quantities)}
              </SettledPriceText>
              <SettledLabel>
                已{message.byMe ? (isSeller ? "出" : "入") : isSeller ? "入" : "出"}账
              </SettledLabel>
            </SettledWrapRight>
          </SettledWrap>
        </OrderMessageTouchableWrap>
        {shouldShowEvaluateButton() && (
          <BottomArea paddingBottom={20}>
            <ButtonWrap onClick={goEvaluate}>
              <ButtonText text="去评价" color={theme.colors.primary} onClick={goEvaluate} />
            </ButtonWrap>
          </BottomArea>
        )}
      </OrderWrap>
    )
  },
)
const OrderComponentMap: Record<string, React.FC<OrderMessageProps>> = {
  [TakeOrderStatus.PENDING]: OrderPending,
  [TakeOrderStatus.CANCELLED]: OrderDefaultTemplate,
  [TakeOrderStatus.SELLER_CANCELLED]: OrderDefaultTemplate,
  [TakeOrderStatus.MATCHING]: OrderWaitForPay,
  [TakeOrderStatus.MATCHING_CANCELLED]: OrderDefaultTemplate,
  [TakeOrderStatus.PENDING_TIMEOUT]: OrderDefaultTemplate,
  [TakeOrderStatus.MATCHING_TIMEOUT]: OrderDefaultTemplate,
  [TakeOrderStatus.DELIVERING]: OrderPaied,
  [TakeOrderStatus.SETTLED]: OrderSettled,
  [TakeOrderStatus.DELIVERY_TIMEOUT]: OrderPaied,
  [TakeOrderStatus.DISPUTE]: OrderDefaultTemplate,
  [TakeOrderStatus.SYSTEM_CANCELLED]: OrderDefaultTemplate,
  [TakeOrderStatus.SYSTEM_SETTLED]: OrderSettled,
  [TakeOrderStatus.EVALUATED]: OrderSettled,
  [TakeOrderStatus.EVALUATED_SR]: OrderSettled,
  [TakeOrderStatus.EVALUATED_ALL]: OrderSettled,
}
export const OrderMessage: React.FC<MessageProps> = observer((props) => {
  const navigation = useNavigation()
  const { eventStore, userStore, chatStore, messageStore, orderStore } = useStores()
  const { message } = props
  const order = message.attach.order

  const Component = useMemo(() => {
    return OrderComponentMap[order.status]
  }, [order.status])

  const isSeller = useMemo(() => {
    return order.seller_id === userStore.currentUser.id
  }, [order.seller_id, userStore.currentUser.id])

  const cancel = useCallback(() => {
    const evt = new Event<TakeOrderStatusData>(EventNames.TAKE_ORDER_CANCEL, {
      trans_no: message?.attach?.order?.trans_no,
      last_message_id: message.message_id,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
  }, [message])

  const approve = useCallback(
    (payment: Payment) => {
      const evt = new Event<TakeOrderStatusData>(EventNames.TAKE_ORDER_APPROVE, {
        trans_no: message?.attach?.order?.trans_no,
        last_message_id: message.message_id,
        payment_id: payment.id,
      })
      eventStore.publish(evt, { flags: FLAG_ACK })
    },
    [message],
  )

  const pay = useCallback(
    (imgs: ImgAttach[]) => {
      const evt = new Event<TakeOrderStatusData>(EventNames.TAKE_ORDER_PAY, {
        trans_no: message?.attach?.order?.trans_no,
        last_message_id: message.message_id,
        imgs,
      })
      eventStore.publish(evt, { flags: FLAG_ACK })
    },
    [message],
  )

  const dispute = useCallback(() => {
    const evt = new Event<TakeOrderStatusData>(EventNames.TAKE_ORDER_DISPUTE, {
      trans_no: message?.attach?.order?.trans_no,
      last_message_id: message.message_id,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
  }, [message])

  const settle = useCallback(() => {
    const evt = new Event<TakeOrderStatusData>(EventNames.TAKE_ORDER_SETTLE, {
      trans_no: message?.attach?.order?.trans_no,
      last_message_id: message.message_id,
    })
    eventStore.publish(evt, { flags: FLAG_ACK })
  }, [message])

  const remind = useCallback(() => {
    // 組成訊息
    const chat = chatStore.current
    const message = chat.newMessage({
      content: "有尚未处理的订单,麻烦请确认",
      type: MessageTypes.TEXT,
      mention_ids: [],
      reply_msg_id: null,
    })
    // 送出訊息
    messageStore.sendMessageByMessageType(message)
  }, [])

  const handleCsCallback = (data: User) => {
    const { chat_id } = genPrivacyChatID(userStore.currentUser.id, data.id)
    const chat = chatStore.chats.get(chat_id)
    chatStore.setCurrent(chat)
    navigation.navigate("Chat", { chat_id: chat.chat_id })
  }

  const contactCs = useCallback(async () => {
    orderStore.onContactCs(handleCsCallback, alertError)
  }, [orderStore.onContactCs])

  const handleOnLongPress = useCallback(() => {
    // if (props.setPopupOptionListModal) {
    //   hapticTrigger()
    //   props.setPopupOptionListModal({ visible: true, message: message })
    // }
  }, [props.setPopupOptionListModal, message])

  return (
    <Component
      {...props}
      order={order}
      isSeller={isSeller}
      cancel={cancel}
      approve={approve}
      pay={pay}
      dispute={dispute}
      settle={settle}
      remind={remind}
      contactCs={contactCs}
      handleOnLongPress={handleOnLongPress}
    />
  )
})
export const WrappedOrderMessage: React.FC<MessageProps> = (props) => {
  const contentOverride = orderStatusText[props.message.attach.order.status].description
  return (
    <MainWrap>
      <WrappedTextMessage {...props} content={contentOverride} setPopupOptionListModal={null} />
      {props.message.byMe ? (
        <MessageSent {...props} Component={OrderMessage} isNoBg={true} />
      ) : (
        <MessageReceived {...props} Component={OrderMessage} isNoBg={true} />
      )}
    </MainWrap>
  )
}
export default WrappedOrderMessage
